import { NEWSLETTER_SET_STATUS, NEWSLETTER_TOGGLE_ERROR_MESSAGE, NEWSLETTER_ERROR } from '../Actions/NewsletterSignup.action';

const DEFAULT_STATE = {
    showErrorText: false,
    errorMessage: '',
    subscriptionSuccess: false,
    error: '',
};

export const newsletterSignup = (state = DEFAULT_STATE, action) => {
    switch (action.type) {
        case NEWSLETTER_SET_STATUS:
        case NEWSLETTER_TOGGLE_ERROR_MESSAGE:
        case NEWSLETTER_ERROR:
            return {
                ...state,
                ...action.payload,
            }
        default:
            return state;
    }
}